import axios from 'axios';
import get from 'lodash/get';
import { Observable, Subject } from 'rxjs';
import nextTick from 'next-tick';
import { addMultipleParams } from 'url-query-handle';
import { switchMap, take, share } from 'rxjs/operators';
import { Cache, cacheAdapterEnhancer } from '@patsnap-utils/common-axios-extensions';
export { Cache } from '@patsnap-utils/common-axios-extensions';

(function () {
  try {
    const ua = navigator ? navigator.userAgent : '';
    return ua.indexOf("MSIE ") > -1 || ua.indexOf("Trident/") > -1;
  } catch (err) {
    return false;
  }
})();

new Date().getTime();
function csrfTokenInterceptor(config) {
  // 不再需要csrfToken
  // if (config && String(config.method).toLowerCase() === 'post') {
  // 	return prepareToken(true, true)
  // 		.then(tkHeader => {
  // 			config.headers = Object.assign(config.headers || {}, tkHeader || {});
  // 			return config;
  // 		});
  // }
  return config;
}
function cacheInterceptor(config) {
  return config;
}
const migrationWarningInterceptor = config => {
  if (config && String(config.method).toLowerCase() === 'get' && config.data) {
    if (console && console.warn) {
      console.warn(`ps-http WARNING: GET requests should use 'params' instead of 'data' as request payload: ${config.url}`);
    }
  }

  return config;
};
function validateResponseBodyStatusInterceptor(response) {
  if (response.config.validateBodyStatus) {
    if (get(response, 'data.status')) {
      return response;
    }

    return Promise.reject(response);
  } else {
    return response;
  }
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

const active = {};
inflight.active = active;

function inflight(unique, doFly) {
  return Promise.all([Promise.resolve(unique), doFly]).then(function (args) {
    const unique = args[0];
    const doFly = args[1];

    if (Array.isArray(unique)) {
      return Promise.all(unique).then(function (uniqueArr) {
        return _inflight(uniqueArr.join(''), doFly);
      });
    } else {
      return _inflight(unique, doFly);
    }
  });

  function _inflight(unique, doFly) {
    function cleanup() {
      delete active[unique];
    }

    if (!active[unique]) {
      active[unique] = new Promise(function (resolve) {
        return resolve(doFly());
      });
      active[unique].then(cleanup, cleanup);
    }

    return active[unique];
  }
}

// fetch方式：任何不是以网络异常引起的问题，包括200，400，500等状态码 response = {status, statusText, body}
function extractData(response) {
  return response.data || response;
} // fetch方式：任何以网络异常引起的问题，以及非200状态码 err = {status, statusText, body}
function inflightCall(uuid, usedConfig, callFn) {
  return inflight(uuid, () => callFn(usedConfig));
}
function sleep(mstime) {
  return new Promise(function (resolve) {
    setTimeout(() => resolve(mstime), mstime);
  });
}
function fastReadAuthToken() {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'token';
  const storeKeyPrefix = 'patsnap';
  const storeItemKey = `${storeKeyPrefix}-authorizations`;
  const tokenParis = JSON.parse(localStorage.getItem(storeItemKey) || '{}');

  if (!tokenParis[type]) {
    return null;
  }

  return tokenParis[type];
}

(function (factory) {
  typeof define === 'function' && define.amd ? define(factory) : factory();
})(function () {

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
  }

  function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
      throw new TypeError("Super expression must either be null or a function");
    }

    subClass.prototype = Object.create(superClass && superClass.prototype, {
      constructor: {
        value: subClass,
        writable: true,
        configurable: true
      }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
  }

  function _getPrototypeOf(o) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
      return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o);
  }

  function _setPrototypeOf(o, p) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
      o.__proto__ = p;
      return o;
    };

    return _setPrototypeOf(o, p);
  }

  function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  function _assertThisInitialized(self) {
    if (self === void 0) {
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }

    return self;
  }

  function _possibleConstructorReturn(self, call) {
    if (call && (typeof call === "object" || typeof call === "function")) {
      return call;
    }

    return _assertThisInitialized(self);
  }

  function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();

    return function _createSuperInternal() {
      var Super = _getPrototypeOf(Derived),
          result;

      if (hasNativeReflectConstruct) {
        var NewTarget = _getPrototypeOf(this).constructor;

        result = Reflect.construct(Super, arguments, NewTarget);
      } else {
        result = Super.apply(this, arguments);
      }

      return _possibleConstructorReturn(this, result);
    };
  }

  function _superPropBase(object, property) {
    while (!Object.prototype.hasOwnProperty.call(object, property)) {
      object = _getPrototypeOf(object);
      if (object === null) break;
    }

    return object;
  }

  function _get(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
      _get = Reflect.get;
    } else {
      _get = function _get(target, property, receiver) {
        var base = _superPropBase(target, property);

        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);

        if (desc.get) {
          return desc.get.call(receiver);
        }

        return desc.value;
      };
    }

    return _get(target, property, receiver || target);
  }

  var Emitter = /*#__PURE__*/function () {
    function Emitter() {
      _classCallCheck(this, Emitter);

      Object.defineProperty(this, 'listeners', {
        value: {},
        writable: true,
        configurable: true
      });
    }

    _createClass(Emitter, [{
      key: "addEventListener",
      value: function addEventListener(type, callback, options) {
        if (!(type in this.listeners)) {
          this.listeners[type] = [];
        }

        this.listeners[type].push({
          callback: callback,
          options: options
        });
      }
    }, {
      key: "removeEventListener",
      value: function removeEventListener(type, callback) {
        if (!(type in this.listeners)) {
          return;
        }

        var stack = this.listeners[type];

        for (var i = 0, l = stack.length; i < l; i++) {
          if (stack[i].callback === callback) {
            stack.splice(i, 1);
            return;
          }
        }
      }
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent(event) {
        if (!(event.type in this.listeners)) {
          return;
        }

        var stack = this.listeners[event.type];
        var stackToCall = stack.slice();

        for (var i = 0, l = stackToCall.length; i < l; i++) {
          var listener = stackToCall[i];

          try {
            listener.callback.call(this, event);
          } catch (e) {
            Promise.resolve().then(function () {
              throw e;
            });
          }

          if (listener.options && listener.options.once) {
            this.removeEventListener(event.type, listener.callback);
          }
        }

        return !event.defaultPrevented;
      }
    }]);

    return Emitter;
  }();

  var AbortSignal = /*#__PURE__*/function (_Emitter) {
    _inherits(AbortSignal, _Emitter);

    var _super = _createSuper(AbortSignal);

    function AbortSignal() {
      var _this;

      _classCallCheck(this, AbortSignal);

      _this = _super.call(this); // Some versions of babel does not transpile super() correctly for IE <= 10, if the parent
      // constructor has failed to run, then "this.listeners" will still be undefined and then we call
      // the parent constructor directly instead as a workaround. For general details, see babel bug:
      // https://github.com/babel/babel/issues/3041
      // This hack was added as a fix for the issue described here:
      // https://github.com/Financial-Times/polyfill-library/pull/59#issuecomment-477558042

      if (!_this.listeners) {
        Emitter.call(_assertThisInitialized(_this));
      } // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
      // we want Object.keys(new AbortController().signal) to be [] for compat with the native impl


      Object.defineProperty(_assertThisInitialized(_this), 'aborted', {
        value: false,
        writable: true,
        configurable: true
      });
      Object.defineProperty(_assertThisInitialized(_this), 'onabort', {
        value: null,
        writable: true,
        configurable: true
      });
      return _this;
    }

    _createClass(AbortSignal, [{
      key: "toString",
      value: function toString() {
        return '[object AbortSignal]';
      }
    }, {
      key: "dispatchEvent",
      value: function dispatchEvent(event) {
        if (event.type === 'abort') {
          this.aborted = true;

          if (typeof this.onabort === 'function') {
            this.onabort.call(this, event);
          }
        }

        _get(_getPrototypeOf(AbortSignal.prototype), "dispatchEvent", this).call(this, event);
      }
    }]);

    return AbortSignal;
  }(Emitter);

  var AbortController = /*#__PURE__*/function () {
    function AbortController() {
      _classCallCheck(this, AbortController); // Compared to assignment, Object.defineProperty makes properties non-enumerable by default and
      // we want Object.keys(new AbortController()) to be [] for compat with the native impl


      Object.defineProperty(this, 'signal', {
        value: new AbortSignal(),
        writable: true,
        configurable: true
      });
    }

    _createClass(AbortController, [{
      key: "abort",
      value: function abort() {
        var event;

        try {
          event = new Event('abort');
        } catch (e) {
          if (typeof document !== 'undefined') {
            if (!document.createEvent) {
              // For Internet Explorer 8:
              event = document.createEventObject();
              event.type = 'abort';
            } else {
              // For Internet Explorer 11:
              event = document.createEvent('Event');
              event.initEvent('abort', false, false);
            }
          } else {
            // Fallback where document isn't available:
            event = {
              type: 'abort',
              bubbles: false,
              cancelable: false
            };
          }
        }

        this.signal.dispatchEvent(event);
      }
    }, {
      key: "toString",
      value: function toString() {
        return '[object AbortController]';
      }
    }]);

    return AbortController;
  }();

  if (typeof Symbol !== 'undefined' && Symbol.toStringTag) {
    // These are necessary to make sure that we get correct output for:
    // Object.prototype.toString.call(new AbortController())
    AbortController.prototype[Symbol.toStringTag] = 'AbortController';
    AbortSignal.prototype[Symbol.toStringTag] = 'AbortSignal';
  }

  function polyfillNeeded(self) {
    if (self.__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL) {
      console.log('__FORCE_INSTALL_ABORTCONTROLLER_POLYFILL=true is set, will force install polyfill');
      return true;
    } // Note that the "unfetch" minimal fetch polyfill defines fetch() without
    // defining window.Request, and this polyfill need to work on top of unfetch
    // so the below feature detection needs the !self.AbortController part.
    // The Request.prototype check is also needed because Safari versions 11.1.2
    // up to and including 12.1.x has a window.AbortController present but still
    // does NOT correctly implement abortable fetch:
    // https://bugs.webkit.org/show_bug.cgi?id=174980#c2


    return typeof self.Request === 'function' && !self.Request.prototype.hasOwnProperty('signal') || !self.AbortController;
  }

  (function (self) {
    if (!polyfillNeeded(self)) {
      return;
    }

    self.AbortController = AbortController;
    self.AbortSignal = AbortSignal;
  })(typeof self !== 'undefined' ? self : global);
});

function defaultInstantiateObservableFunction(createFn) {
  return new Observable(createFn);
}

function psHttpObservableInit(psHttp) {
  let instantiateObservableFunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultInstantiateObservableFunction;
  const flightCtrl = new FlightsCtrlCenter();
  return function psHttp$(config) {
    function createFn(observer) {
      const controller = new AbortController();

      function cancelReq() {
        controller.abort();
      }

      let requestDone = false;
      flightCtrl.add(config.uuid);
      psHttp(Object.assign({}, config, {
        signal: controller.signal
      })).then(function (o) {
        requestDone = true;
        flightCtrl.remove(config.uuid);
        return o;
      }, error => {
        requestDone = true;
        flightCtrl.remove(config.uuid);
        throw error;
      }).then(extractData).then(data => {
        observer.next(data);
        observer.complete();
      }).catch(error => {
        observer.error(error);
      });
      return function () {
        if (config.uuid) {
          if (requestDone) ; else {
            nextTick(function () {
              if (flightCtrl.hasLastOneActivesFlightsByUuid(config.uuid)) {
                cancelReq();
              }
            });
          }
        } else {
          cancelReq();
        }
      };
    }

    return instantiateObservableFunction(createFn);
  };
}

class FlightsCtrlCenter {
  constructor() {
    _defineProperty(this, "actives", {});
  }

  changeCountById(uuid, delta) {
    if (!uuid) {
      return;
    }

    if (!this.actives[uuid]) {
      this.actives[uuid] = 0;
    }

    this.actives[uuid] += delta;

    if (this.actives[uuid] <= 0) {
      delete this.actives[uuid];
    }

    return this.actives[uuid];
  }

  add(uuid) {
    this.changeCountById(uuid, 1);
  }

  remove(uuid) {
    this.changeCountById(uuid, -1);
  }

  hasLastOneActivesFlightsByUuid(uuid) {
    return this.actives[uuid] === 1;
  }

}

let _passport = undefined;
function postByForm(newWindowOrFormElement, path, params) {
  // The rest of this code assumes you are not using a library.
  // It can be made less wordy if you use one.
  const provideForm = newWindowOrFormElement instanceof HTMLFormElement;
  let form;

  if (provideForm) {
    form = newWindowOrFormElement;
  } else {
    const document = window.document;
    var method = 'post';
    form = document.createElement('form');
    form.setAttribute('method', method);
    form.setAttribute('action', path);

    if (newWindowOrFormElement === true) {
      form.setAttribute('target', '_blank');
    } else {
      form.setAttribute('target', '_self');
    }
  }

  if (_passport) {
    _passport.getAccessToken(true).catch(error => {
      _passport.passportRuntimeOptions.redirectToLogin(error);

      throw error;
    }).then(afterPrepareToken);
  } else {
    afterPrepareToken();
  }

  function afterPrepareToken() {
    const authToken = fastReadAuthToken();

    if (authToken) {
      form.setAttribute('action', addMultipleParams(path || form.getAttribute('action'), {
        jwt: authToken
      }));
    }

    loopParams(params, function (key, value) {
      apendFormInput(form, key, value);
    });

    if (provideForm) {
      form.submit();
      loopParams(params, function (key, value) {
        try {
          removeInputElementByKey(key, form);
        } catch (err) {
          console.error(err);
        }
      });
    } else {
      window.document.body.appendChild(form);
      form.submit();
      form.parentNode.removeChild(form);
    }
  }
}

function loopParams(params, everyCall) {
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      // const pValue = params[key];
      if (Array.isArray(params[key])) {
        params[key].forEach(value => {
          everyCall(key, value);
        });
      } else {
        const pValue = params[key];
        everyCall(key, pValue);
      }
    }
  }
}

function apendFormInput(form, key, value) {
  const simpleFlag = document.createElement('input');
  simpleFlag.setAttribute('type', 'hidden');
  simpleFlag.setAttribute('name', key);
  simpleFlag.setAttribute('value', value);
  form.appendChild(simpleFlag);
}

function removeInputElementByKey(key, form) {
  const list = form.querySelectorAll(`[name=${key}]`);

  for (let i = list.length - 1; 0 <= i; i--) {
    if (list[i] && list[i].parentElement) {
      list[i].parentElement.removeChild(list[i]);
    }
  }
}

function setPostByFormPassport(passport) {
  if (passport && typeof passport.exchangeRefreshForAccess === "function" && passport.passportRuntimeOptions) {
    _passport = passport;
  } else {
    console.error(new TypeError(`setPassport in 'postByForm' param type error, 
        need @patsnap-utils/passport > 0.6`));
  }
}

const redirectingError = new Error('Please login, redirecting...');

function redirectingHolder(error) {
  return sleep(2500).then(() => Promise.reject(error || redirectingError));
}

function defaultHandler(error, code) {
  let redirectUrl = get(error, 'response.data.redirectUrl');

  if (redirectUrl) {
    window.location.href = redirectUrl;
    return redirectingHolder(error);
  }

  return Promise.reject(error);
}

function generateExceptionRedirector(codeOrCodes) {
  let callbackOrLocation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultHandler;
  return function exceptionPreHandler(error) {
    let codes = Array.isArray(codeOrCodes) ? codeOrCodes : [codeOrCodes];
    let statusCode = get(error, 'response.status');

    if (codes.indexOf(statusCode) >= 0) {
      if (typeof callbackOrLocation === 'function') {
        return callbackOrLocation(error, statusCode);
      } else if (typeof callbackOrLocation === 'string') {
        window.location.href = callbackOrLocation || '/';
        return redirectingHolder(error);
      }
    }

    return Promise.reject(error);
  };
}

const defRequestAsPromise = {
  autoUnsub: true,
  newSubscriptionCallback: subscription => null
};
class RequestChannel {
  constructor() {
    let asyncCallback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : psHttp$;

    _defineProperty(this, "_asyncCallback", void 0);

    _defineProperty(this, "subject", void 0);

    _defineProperty(this, "_prePipes", void 0);

    _defineProperty(this, "_flatOperator", void 0);

    _defineProperty(this, "req$", void 0);

    this._asyncCallback = asyncCallback;
    this.subject = new Subject();
    this._prePipes = [];
    this._flatOperator = switchMap;
    this.setReq$();
  }

  static toPromise(obs$) {
    let newSubscriptionCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : sub => null;
    return new Promise((resolve, reject) => {
      let subscription = obs$.pipe(take(1)).subscribe({
        next: resolve,
        error: reject
      });
      newSubscriptionCallback(subscription);
    });
  }

  get flatOperator() {
    return this._flatOperator;
  }
  /**
   * 拍平方法
   * @param {Function} operator 前置的pipe
   */


  set flatOperator(operator) {
    this._flatOperator = operator;
    this.setReq$();
  }

  get prePipes() {
    return this._prePipes;
  }
  /**
   * 推入请求
   * @param {Array} pipeArray 前置的pipe
   */


  set prePipes(pipeArray) {
    this._prePipes = [].concat(pipeArray);
    this.setReq$();
  }

  setReq$() {
    this.req$ = this.subject.pipe( // @ts-ignore
    ...(this.prePipes || []), this.flatOperator(reqConfig => this._asyncCallback(reqConfig)), share());
  }
  /**
   * 推入请求
   * @param {Object||Function} conf psHttp配制
   */


  add(conf) {
    this.subject.next(conf);
  }
  /**
   * 订阅
   * @param {Function} next 获取数据的回调
   * @param {Function} error  请求/Promise出错的回调
   * @return {Subscription} subscription Subscription object
   */


  sub(next, error) {
    return this.req$.pipe(take(1)).subscribe({
      next,
      error
    });
  }

  requestAsPromise(reqConf) {
    let opt = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    const _opt = Object.assign({}, defRequestAsPromise, opt);

    return new Promise((resolve, reject) => {
      let subscription = _opt.autoUnsub ? this.sub(resolve, reject) : this.req$.subscribe({
        next: resolve,
        error: reject
      });

      _opt.newSubscriptionCallback(subscription);

      this.add(reqConf);
    });
  }

}

const {
  Cancel,
  CancelToken
} = axios;

const psAxios = createPsAxiosInstance();
const defaultActiveInterceptors = psAxios.psInterceptors;
function createPsAxiosInstance(options, customCache) {
  const cache = customCache || new Cache({
    max: 500,
    maxAge: 1000 * 60 * 60 * 30 // 0.5hour

  });
  let inst = axios.create({
    timeout: 62000,
    headers: {
      'x-requested-with': 'XMLHttpRequest'
    },
    adapter: cacheAdapterEnhancer(axios.defaults.adapter, {
      cacheFlag: 'cache',
      defaultCache: cache,
      enabledByDefault: false
    }),
    ...options
  });
  let interceptors = {
    csrfTokenInterceptor: inst.interceptors.request.use(csrfTokenInterceptor, error => Promise.reject(error)),
    migrationWarningInterceptor: inst.interceptors.request.use(migrationWarningInterceptor),
    cacheInterceptor: inst.interceptors.request.use(cacheInterceptor),
    validateResponseBodyStatusInterceptor: inst.interceptors.response.use(validateResponseBodyStatusInterceptor)
  };
  inst.psInterceptors = interceptors;

  function psHttp(config) {
    let instance = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : inst;
    let usedConfig = Object.assign({}, config);

    if (usedConfig.uuid) {
      return inflightCall(usedConfig.uuid, usedConfig, instance);
    } else {
      return instance(usedConfig);
    }
  }

  inst.psHttp = psHttp;
  inst.defCache = cache;
  inst.psHttp$ = psHttpObservableInit(psHttp);
  return inst;
}
const psHttp = psAxios.psHttp;
const psHttp$ = psAxios.psHttp$;

export { Cancel, CancelToken, RequestChannel, createPsAxiosInstance, csrfTokenInterceptor, psHttp as default, defaultActiveInterceptors, fastReadAuthToken, generateExceptionRedirector, postByForm, psAxios, psHttp$, psHttpObservableInit, setPostByFormPassport };
//# sourceMappingURL=ps-http.esm.js.map
